import React, { useState, useEffect } from 'react';

const AngleContentsAdd = ({ onClose, onSave, initialData, isEditMode = false }) => {
  const [modalData, setModalData] = useState({
    name: '',
    data: '',
    type: '없음',
    direction: 'horizontal'
  });

  useEffect(() => {
    if (initialData) {
      setModalData({
        name: initialData.name,
        data: initialData.data || '',
        type: initialData.type || '없음',
        direction: initialData.direction || 'horizontal'
      });
    }
  }, [initialData]);

  // URL 입력 핸들러
  const handleUrlChange = (type, value) => {
    switch (type) {
      case 'motionData':
        setModalData({ ...modalData, data: value });
        break;
      case 'angleImage1':
        setModalData({ ...modalData, image1: value });
        break;
      case 'angleImage2':
        setModalData({ ...modalData, image2: value });
        break;
    }
  };

  // 불러오기 버튼 핸들러
  const handleUpload = () => {
    // 실제 구현에서는 파일 업로드 로직 추가
    console.log('Upload angle data');
  };

  // 저장 핸들러
  const handleSave = () => {
    const newAngle = {
      id: initialData ? initialData.id : Date.now(), // 수정 시 기존 ID 유지
      name: modalData.name,
      type: modalData.type,
      motionData: modalData.data,
      angleDirection: modalData.direction,
      angleImage1: modalData.image1,
      angleImage2: modalData.image2,
      selected: false
    };

    onSave(newAngle);
  };

  return (
    <div className="modal-overlay active">
      <div className="modal-container">
        <div className="modal-header">
          <h3 className="modal-title">앵글 {isEditMode ? '수정' : '추가'}</h3>
          <button className="modal-close" onClick={onClose}>
            <i className="ri-close-line"></i>
          </button>
        </div>
        <div className="modal-body">
          <div className="modal-content">
            <div className="modal-form-group">
              <div className="modal-row-container">
                <div className="modal-column">
                  <label className="modal-label">앵글명</label>
                  <input
                    type="text"
                    className="modal-input"
                    id="angle-name"
                    value={modalData.name}
                    onChange={(e) => setModalData({ ...modalData, name: e.target.value })}
                    placeholder="앵글명을 입력하세요"
                  />
                </div>
                <div className="modal-column">
                  <label className="modal-label">모션 데이터</label>
                  <div className="modal-import-with-button">
                    <input
                      type="text"
                      className="modal-input"
                      id="angle-data"
                      value={modalData.data}
                      onChange={(e) => handleUrlChange('motionData', e.target.value)}
                      placeholder="URL"
                    />
                    <button 
                      className="modal-btn modal-btn-secondary" 
                      id="import-data-btn"
                      onClick={handleUpload}
                    >
                      불러오기
                    </button>
                  </div>
                </div>
              </div>

              <div className="angle-motion">
                <img src="angleMotions/angle_motion.png" alt="angle_motion" />
              </div>

              <div className="modal-form-group">
                <div className="modal-row-container">
                  <div className="modal-column">
                    <label className="modal-label">앵글 타입</label>
                    <div className="modal-select-container">
                      <select
                        className="modal-select"
                        id="angle-type"
                        value={modalData.type}
                        onChange={(e) => setModalData({ ...modalData, type: e.target.value })}
                      >
                        <option value="photo">사진</option>
                        <option value="video">동영상</option>
                        <option value="combined">동영상 + 사진</option>
                      </select>
                      <i className="ri-arrow-down-s-line modal-select-arrow"></i>
                    </div>
                  </div>
                  <div className="modal-column">
                    <label className="modal-label">앵글 방향</label>
                    <div className="modal-select-container">
                      <select
                        className="modal-select"
                        id="angle-direction"
                        value={modalData.direction}
                        onChange={(e) => setModalData({ ...modalData, direction: e.target.value })}
                      >
                        <option value="front">정면</option>
                        <option value="left">좌측</option>
                        <option value="right">우측</option>
                      </select>
                      <i className="ri-arrow-down-s-line modal-select-arrow"></i>
                    </div>
                  </div>
                </div>

                <div className="modal-form-group">
                  <div className="modal-row-container">
                    <div className="modal-column">
                      <label className="modal-label">앵글 선택 이미지 (클릭 전)</label>
                      <div className="modal-import-with-button">
                        <input
                          type="text"
                          className="modal-input"
                          id="angle-image1"
                          value={modalData.image1}
                          onChange={(e) => handleUrlChange('angleImage1', e.target.value)}
                          placeholder="URL"
                        />
                        <button 
                          className="modal-btn modal-btn-secondary" 
                          id="import-image1-btn"
                          onClick={handleUpload}
                        >
                          불러오기
                        </button>
                      </div>
                      <div className="modal-data-image">
                        <img src="images/angleData/angle_data.png" alt="angle_data" />
                      </div>
                    </div>
                    <div className="modal-column">
                      <label className="modal-label">앵글 선택 이미지 (클릭 후)</label>
                      <div className="modal-import-with-button">
                        <input
                          type="text"
                          className="modal-input"
                          id="angle-image2"
                          value={modalData.image2}
                          onChange={(e) => handleUrlChange('angleImage2', e.target.value)}
                          placeholder="URL"
                        />
                        <button 
                          className="modal-btn modal-btn-secondary" 
                          id="import-image2-btn"
                          onClick={handleUpload}
                        >
                          불러오기
                        </button>
                      </div>
                      <div className="modal-data-image">
                        <img src="images/angleData/angle_data2.png" alt="angle_data2" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button 
            className="modal-btn modal-btn-cancel" 
            onClick={onClose}
          >
            취소
          </button>
          <button 
            className="modal-btn modal-btn-primary" 
            onClick={handleSave}
            disabled={!modalData.name}
          >
            {isEditMode ? '수정' : '저장'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AngleContentsAdd;





